import { Injectable } from '@angular/core';
import { handleError } from '@core/helpers';
import { GoogleMapsApiService } from '@core/services/google-maps-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  loadGoogleMapsApi,
  loadGoogleMapsApiFailure,
  loadGoogleMapsApiSuccess,
} from './actions';

@Injectable()
export class GoogleMapsApiEffects {
  getGoogleMapsApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadGoogleMapsApi),
      switchMap(() =>
        this.googleMapsApiService.loadGoogleMapsApi().pipe(
          map(() => loadGoogleMapsApiSuccess()),
          catchError((error) => handleError(error, loadGoogleMapsApiFailure)),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private googleMapsApiService: GoogleMapsApiService,
  ) {}
}
